import logo from './logo.svg';
import './App.css';

import Wrapper from './Wrapper';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Thanks from './Thanks';
import ReceptionistWrapper from './ReceptionistWrapper';
import SecondReceptionistWrapper from './SecondReceptionistWrapper';
import AdminReceptionistWrapper from './AdminReceptionistWrapper';
import HadrahaPage from './HadrahaPage';
import WhatsappPage from './WhatsappPage';

function StaticPage({ path }) {
  useEffect(() => { window.location.replace(path); }, [path]);
  return null;
}

function App() {
  return <>
  <Router>
    <Routes>

    <Route path="/" index element={<Wrapper/>}/>
    <Route path="/תודה" index element={<Thanks/>}/>
    <Route path="/קורס" element={<ReceptionistWrapper/>}/>
    <Route path="/קורס-ב" element={<SecondReceptionistWrapper/>}/>
    <Route path="/קורס-אדמיניסטרציה" element={<AdminReceptionistWrapper/>}/>
    <Route path="/הדרכה" element={<HadrahaPage/>}/>
    <Route path="/whatsapp" element={<WhatsappPage/>}/>
    <Route path="/ty" element={<StaticPage path="/ty/" />}/>
    <Route path="/lp" element={<StaticPage path="/lp/" />}/>
    <Route path="/wc" element={<StaticPage path="/wc/" />}/>
    <Route path="/book" element={<StaticPage path="/book/" />}/>
    <Route path="/thank-you" element={<StaticPage path="/thank-you/" />}/>
    <Route path="/ty-lead" element={<StaticPage path="/ty-lead/" />}/>

 </Routes>
 </Router>
  </>
}

export default App;
